module.exports = __webpack_public_path__ + "media/images/icon__point--gained-e4f1e857eb5e240727758cc99a83f6ca.png";